import { axios } from '@Root/API'

export const putIncludeInHesa = payload => {
  return axios.put(`students/course-session/include-in-hesa`, payload)
}
